import {
  OperationParameter,
  OperationURLParameter,
  OperationQueryParameter
} from "@azure/core-client";
import {
  FareSelectorRequest as FareSelectorRequestMapper,
  FareRequest as FareRequestMapper,
  FareRequestByBundle as FareRequestByBundleMapper
} from "../models/mappers";

export const contentType: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};

export const body: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: FareSelectorRequestMapper
};

export const accept: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};

export const $host: OperationURLParameter = {
  parameterPath: "$host",
  mapper: {
    serializedName: "$host",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};

export const body1: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: FareRequestMapper
};

export const ticketCode: OperationQueryParameter = {
  parameterPath: "ticketCode",
  mapper: {
    serializedName: "ticketCode",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const body2: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: FareRequestByBundleMapper
};

export const ticketId: OperationURLParameter = {
  parameterPath: "ticketId",
  mapper: {
    serializedName: "ticketId",
    required: true,
    type: {
      name: "String"
    }
  }
};
